import chipBlue from '../../../assets/images/chips/blue.svg'
import chipGreen from '../../../assets/images/chips/green.svg'
import chipOrange from '../../../assets/images/chips/orange.svg'
import chipPink from '../../../assets/images/chips/pink.svg'
import chipPurple from '../../../assets/images/chips/purple.svg'
import chipRed from '../../../assets/images/chips/red.svg'
import chipViolet from '../../../assets/images/chips/violet.svg'
import chipYellow from '../../../assets/images/chips/yellow.svg'

export type CoinColorType =
  | 'green'
  | 'blue'
  | 'violet'
  | 'purple'
  | 'yellow'
  | 'orange'
  | 'red'
  | 'pink'

export const Coin = (props: { color: CoinColorType; className?: string }) => {
  const coinImage: Record<CoinColorType, string> = {
    green: chipGreen,
    blue: chipBlue,
    violet: chipViolet,
    purple: chipPurple,
    yellow: chipYellow,
    orange: chipOrange,
    red: chipRed,
    pink: chipPink,
  }

  return (
    <img
      src={coinImage[props.color]}
      className={props.className}
      alt={`${props.color} chip`}
    />
  )
}
